
import Vue from 'vue'
import ReportTable, { ColumnConfig } from "@/components/ReportTable.vue";
import ReportControls, { Account, ReportSpecByWeek } from "@/components/ReportControls.vue";
import axios from "axios";
import XLSX from "xlsx";

export default Vue.extend({
  name: "PostcodeMargin",
  components: { ReportControls, ReportTable },
  data() {
    return {
      spec: {} as ReportSpecByWeek,
      headers: [],
      data: [],
      breakdowns: {},
      loading: true,
    };
  },
  computed: {
    dataUrl(): string {
      const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';
      const { depot, from, to } = this.spec;
      return `${BASE_URL}/reports/postcode-margin/${depot}/${from.year}/${from.week}/${to.year}/${to.week}/`;
    },
    columnConfig(): Array<ColumnConfig<string> | ColumnConfig<number>> {
      return [{}].concat(this.headers.slice(1).map(() => ({ format: "currency" })));
    },
  },
  watch: {
    async spec() {
      this.loading = true;
      const response = await axios.get(this.dataUrl, {
        params: {
          account_codes: this.spec.accountCodes.flatMap((a: Account) => a.codes),
        },
      });
      this.headers = response.data.headers;
      this.data = response.data.data;
      this.loading = false;
    },
  },
  methods: {
    async toggleBreakdown(postcode: { key: string, sort?: { index: number, direction: 'ASC' | 'DESC' } }) {
      const idx = postcode.sort?.index ?? 0;
      const descending = postcode.sort?.direction === 'DESC';

      function sortFunc(a: Array<string | number>, b: Array<string | number>) {
        let first;
        let second;
        if (idx >= a.length) {
          // Sort by total
          const aTotal = a.slice(1).reduce((x, y) => (x as number) + (y as number), 0);
          const bTotal = b.slice(1).reduce((x, y) => (x as number) + (y as number), 0);
          first = descending ? bTotal : aTotal;
          second = descending ? aTotal : bTotal;
        } else {
          first = descending ? b[idx] : a[idx];
          second = descending ? a[idx] : b[idx];
        }
        if (typeof first === 'string') {
          return first.localeCompare(second as string, undefined, { numeric: true });
        } else {
          return first - (second as number);
        }
      }

      if (postcode.key in this.breakdowns) {
        this.$delete(this.breakdowns, postcode.key);
      } else {
        const response = await axios.get(this.dataUrl, {
          params: {
            account_codes: this.spec.accountCodes.flatMap((a: Account) => a.codes),
            pc: postcode.key,
          },
        });
        response.data.data.sort(sortFunc);
        this.$set(this.breakdowns, postcode.key, response.data.data);
      }
    },
    download() {
      const wb = XLSX.utils.book_new();
      const networkSheet = XLSX.utils.table_to_sheet((this.$refs.network as Vue).$el);
      XLSX.utils.book_append_sheet(wb, networkSheet, 'Postcode Margins');
      const { depot, from, to } = this.spec;
      XLSX.writeFile(wb, `Postcode Margins for Depot ${depot} - ${from.year}${to.week}
      to ${to.year}${to.week}.xlsx`);
    },

  },
});
